<template>
  <b-field label="Data range">
      <b-slider :min="0"
                :max="countryDataAvailable ? country.length - 1 : 0"
                v-model="dataRange"
                lazy
                :custom-formatter="formatDataRangeLabel"
                :disabled="!countryDataAvailable"/>
    </b-field>
</template>

<script>
import actions from '../../store/actions';

export default {
  name: 'RangeSelector',
  computed: {
    country() {
      return this.$store.state.country;
    },
    countryDataAvailable() {
      return this.country.length > 0;
    },
    dataRange: {
      get() {
        return this.$store.state.dataRange;
      },
      set(range) {
        this.$store.dispatch(actions.CHANGE_DATA_RANGE, range);
      },
    },
  },
  methods: {
    formatDataRangeLabel(idx) {
      return this.countryDataAvailable
        ? new Date(this.country[idx].day).toDateString()
        : '';
    },
  },
};
</script>

<style scoped></style>
